<script>
  export let ligament;
  export let refreshCallback = () => {};
</script>

<span class="date-label">Ligament</span>
<select class="form-select" bind:value={ligament} on:change={refreshCallback}>
  <option value="WLIS/NEAR">LIS/NEAR</option>
  <option value="WLIS/USDT">LIS/USDT</option>
  <option value="NEAR/USDT">NEAR/USDT</option>
  <option value="MATIC/USDT">MATIC/USDT</option>
  <option value="WLIS/MATIC">LIS/MATIC</option>
</select>